import { FETCH_LIST_CATEGORY_PARENT_SUCCESS } from "redux/ActionTypes/CategoryParentActionTypes";

const initialState = {
  list: [],
};

const CategoryParentReducers = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LIST_CATEGORY_PARENT_SUCCESS: {
      const newList = [...action.payload];
      return { ...state, list: newList };
    }
    default:
      return { ...state };
  }
};

export default CategoryParentReducers;
